<template>
    <HeaderView />

    <div class="container-fluid">

        <BannerView v-if="showBanner" />

        <div class="header-image image-3"></div>

        <div class="container">
            <div class="mission-container mt-5">
                <p class="caption">Over Ons</p>

                <div class="row justify-content-center">
                    <div class="text-column-left col-md-6">
                        <p class="">
                            <b>Iedereen verdient een fijn thuis.</b> Of het nu gaat om een rustige
                            buurt, een woning die past bij uw leefsituatie of de zekerheid van een betaalbare huur –
                            bij LeefGoed werken we elke dag aan een plek waar mensen echt kunnen leven.
                        </p>
                        <p>
                            Als woningcorporatie in de regio {{ CityName }} beheren wij ruim 10.000
                            woningen, verspreid over meerdere gemeenten. Van de levendige stad tot de rustige
                            dorpen: <b>wij zijn er voor een brede en diverse groep huurders</b>. Die verscheidenheid
                            zien wij niet als een uitdaging, maar als onze kracht.

                            <span class="signature-block">
                                <img src="@/assets/avatar_jennifer_da_silva.png" class="signature-avatar" alt="Jennifer da Silva" />
                                <span>
                                    <span class="signature">Jennifer da Silva, directeur LeefGoed</span>
                                    <img src="@/assets/signature.png" width="240" />
                                </span>
                            </span>
                        </p>
                    </div>
                    <div class="image-column-right col-md-6">
                        <BlockInfographic infographic="infographic_2b.png"/>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="info-box mt-5 mb-5">
                            <p class="caption">Raad van commissarissen</p>
                            <p>
                                De raad van commissarissen (rvc) bestaat uit zeven leden met ieder een eigen
                                achtergrond en expertise. De raad adviseert en houdt toezicht op het beleid van de
                                directeur-bestuurder. Voorzitter van de rvc is Kees Hoekstra.
                            </p>
                            <div class="info-box-person">
                                <img src="@/assets/avatar_kees_hoekstra.png" class="info-box-avatar" alt="Kees Hoekstra" />
                                <span>
                                    <span class="info-box-name">Kees Hoekstra</span>
                                    <span class="info-box-role">Voorzitter rvc LeefGoed</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <a href="/" class="admin-button small mb-4">
                        <svg viewBox="0 0 32 32" x="0" y="0" width="32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="Icon_7"
                                d="M13.97245,22.54195c0.5009,0.601 1.3942,0.682 1.9953,0.181c0.601,-0.501 0.6822,-1.394 0.1813,-1.995zM10.36515,15.99995l-1.0884,-0.907c-0.4378,0.525 -0.4378,1.289 0,1.814zM16.14905,11.27195c0.5009,-0.601 0.4197,-1.494 -0.1813,-1.995c-0.6011,-0.501 -1.4944,-0.42 -1.9953,0.181zM21.63475,17.41695c0.7824,0 1.4166,-0.635 1.4166,-1.417c0,-0.782 -0.6342,-1.417 -1.4166,-1.417zM16.14905,20.72795l-4.6956,-5.635l-2.1767,1.814l4.6957,5.635zM11.45345,16.90695l4.6956,-5.635l-2.1766,-1.814l-4.6957,5.635zM10.36515,17.41695h11.2696v-2.834h-11.2696zM7.98605,7.98595c4.426,-4.426 11.6018,-4.426 16.0278,0l2.0034,-2.003c-5.5324,-5.533 -14.5022,-5.533 -20.0346,0zM24.01385,7.98595c4.4259,4.426 4.4259,11.602 0,16.028l2.0034,2.003c5.5327,-5.532 5.5327,-14.502 0,-20.034zM24.01385,24.01395c-4.426,4.426 -11.6018,4.426 -16.0278,0l-2.0034,2.003c5.5324,5.533 14.5022,5.533 20.0346,0zM7.98605,24.01395c-4.4259,-4.426 -4.4259,-11.602 0,-16.028l-2.0034,-2.003c-5.5325,5.532 -5.5325,14.502 0,20.034z"
                                fill="#000000" xmlns="http://www.w3.org/2000/svg" />
                        </svg>
                        &nbsp;&nbsp;Terug
                    </a>
                </div>
            </div>
        </div>

        <div class="header-image image-1"></div>

        <!-- <div class="container mt-5">
            <div class="row">
                <div class="news-container">
                    <p>LeefGoed is er voor mensen die een betaalbare en prettige woning zoeken in de regio {{ CityName }}.
                        Wij verhuren grondgebonden woningen, appartementen en zorgvastgoed aan mensen met een
                        laag tot middeninkomen. Ons bezit beslaat meerdere gemeenten en omvat gemengde bouwstijlen
                        – van vooroorlogse woningen tot moderne nieuwbouw.
                    </p>
                </div>
            </div>
        </div> -->

        <!-- <div class="container mt-5">
            <div class="row">
                <p>
                    <img src="@/assets/infographic_2b.png" style="border-radius: 6px; box-shadow: 0 5px 20px rgba(0,0,0,0.2);"/>
                </p>
            </div>
        </div> -->

        <div class="container mt-5 d-none">
            <div class="row">
                <div class="news-container">
                    <p class="caption">Uitgangspunten</p>
                    <ul>
                        <li>
                            <strong>Betaalbaar wonen als vertrekpunt.</strong>
                            <p>Wij staan voor toegankelijke huurwoningen voor iedereen die dat nodig heeft.
                                Eerlijk toewijzen, transparant communiceren en oog voor de mens achter de aanvraag.
                            </p>
                        </li>
                        <li>
                            <strong>Oog voor leefbaarheid.</strong>
                            <p>Een woning is meer dan vier muren. Wij investeren in prettige buurten, actieve
                                samenwerking met bewoners en aandacht voor de kwaliteit van de woonomgeving.</p>
                        </li>
                        <li>
                            <strong>Werken met en voor huurders.</strong>
                            <p>Onze huurders zijn onze belangrijkste gesprekspartner. Via de huurdersorganisatie en
                                directe contactmomenten luisteren wij naar wat er leeft en wat beter kan.</p>
                        </li>
                        <li>
                            <strong>Samenwerking in de regio.</strong>
                            <p>Goede volkshuisvesting maak je niet alleen. Wij werken intensief samen met
                                gemeenten, zorgpartners en andere corporaties om de woonopgave in de regio aan te pakken.</p>
                        </li>
                        <li>
                            <strong>Aandacht voor kwetsbare doelgroepen.</strong>
                            <p>Van jongeren die voor het eerst op zichzelf wonen tot ouderen die zorg nodig hebben
                                – wij zorgen voor passende woonoplossingen voor mensen in uiteenlopende
                                situaties.</p>
                        </li>
                        <li>
                            <strong>Duurzaam en toekomstgericht.</strong>
                            <p>Wij verduurzamen onze woningvoorraad stap voor stap. Voor lagere woonlasten,
                                een beter leefklimaat en een kleinere ecologische voetafdruk.</p>
                        </li>
                    </ul>
                    <p>
                        LeefGoed staat voor eerlijk, betrokken en verantwoord woningbeheer. Elke beslissing die
                        wij nemen, toetsen wij aan &eacute;&eacute;n vraag: draagt dit bij aan goed wonen voor onze huurders?
                    </p>
                    <!-- <p class="align-right">
                        <ButtonView text="Onze achtergrond" background="dark" @click="buttonClicked"
                            class="btn-lees-meer" />
                    </p> -->
                </div>
            </div>
        </div>

        <!-- <div class="header-image image-2" style="margin-top:3rem;"></div> -->
    </div>

    <FooterView />
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import BannerView from '@/components/BannerView.vue';
import FooterView from '@/components/FooterView.vue';
import BlockInfographic from '@/components/BlockInfographic.vue';
import constants from '@/constants.js';

export default {
    name: 'AboutUs',
    components: {
        HeaderView, BannerView, FooterView, BlockInfographic
    },
    data() {
        return {
            CityName: constants.CityName
        };
    }
};
</script>

<style scoped>
.container-fluid {
    margin-bottom: 3em;
}

.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    padding-bottom: 1.3125rem;
    background: white;
}

.text-column-left {
    margin-top: 3.75rem;
}

.fictional-client-container {
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}

.signature-block {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    margin-top: 2rem;
}

.signature-avatar {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.signature {
    font-size: 15pt;
    display: block;
}

.info-box {
    background: var(--color-primary-extra-light);
    /* border-left: 4px solid #b9cdf0; */
    border-radius: 6px;
    padding: 2em 2.5em;
}

.info-box-person {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    margin-top: 1.5rem;
}

.info-box-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.info-box-name {
    display: block;
    font-weight: bold;
}

.info-box-role {
    display: block;
}

.header-image {
    width: 100%;
    height: 11em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.image-1 {
    background-image: url(@/assets/carousel_2.jpg);
}

.image-2 {
    background-image: url(@/assets/about-us.jpg);
}

.image-3 {
    background-image: url(@/assets/office-with-logo-a.jpg);
}

.image-4 {
    background-image: url(@/assets/office-with-logo.jpg);
}

.news-container {
    background: #f6f9ff;
    padding: 2.5em;
}

.news-container p {
    text-align: justify;
}

.news-container h2 {
    color: #444;
    font-weight: normal;
    margin-bottom: 0.5em;
    font-size: 1.9rem;
}

.news-container p.align-right {
    text-align: right;
}
</style>